import type { PlatformContent } from "../content/platform";
import { CtaBandSection, PageHero, SpecBlock } from "./common";

export function PlatformSections({ content }: { content: PlatformContent }) {
  const c = content;
  return (
    <>
      <PageHero path="hero" eyebrow={c.hero.eyebrow} heading={c.hero.heading} lede={c.hero.lede} note={c.hero.note} />

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          {c.specs.map((spec, i) => (
            <SpecBlock spec={spec} path={`specs.${i}`} key={i} />
          ))}
        </div>
      </section>

      <CtaBandSection path="ctaBand" content={c.ctaBand} />
    </>
  );
}
